import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponentTableComponent } from 'src/app/core/view/component/table/view-component-table.component';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { OrganizationsDetailGeneralComponent } from 'src/app/organizations/organizations-detail/organizations-detail-general/organizations-detail-general.component';
import { TasksDetailComponent } from '../tasks-detail/tasks-detail.component';
import { TasksService } from '../tasks.service';

@Component({
  selector: 'app-tasks-list',
  templateUrl: './tasks-list.component.html',
  styleUrls: ['./tasks-list.component.scss']
})
export class TasksListComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public tasksFilters: any = {
    is_finished: false,
  };

  constructor(
    private tasksService: TasksService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private coreDialogService: CoreDialogService,
    private router: Router,
    private viewsService: ViewsService,
  ) {
    this.tasksFilters.responsible_user_id = (localStorage.getItem("isSuperAdmin") === 'false' ? parseInt(localStorage.getItem("userId")) : null);
  }

  ngOnInit(): void {
  }

  loadPrevOrNext(id: number) {
    let table: ViewComponentTableComponent = this.view.getComponent("tasks.list.results");
    let prev: any = null;
    let next: any = null;
    let task: any = null;
    for (let i = 0; i < table.rows.length; i++) {
      if (table.rows[i].id == id) {
        task = table.rows[i];
        if ((i + 1) <= (table.rows.length - 1)) next = table.rows[i + 1];
        break;
      }
      prev = table.rows[i];
    }

    if (task != null) this.openTask(task, prev, next);
  }

  viewTask(task) {
    this.openTask(task, null, null);
  }

  openTask(task, prev, next) {
    var params2: any = {};
    var params = {
      _sortBy: "task_action_scheduled_date",
      _sortDirection: "asc"
    };
    params = Object.assign(params, this.tasksFilters);
    if (params != null) {
      Object.keys(params).forEach(key => {
        if (typeof (params[key]) != "undefined" && params[key] != null) params2[key] = params[key];
      });
    }
    // Convierte el objeto params a una cadena JSON
    var paramsString = JSON.stringify(params);

    // Guarda la cadena JSON en el localStorage con la clave "tasks.list"
    localStorage.setItem("tasks.list", paramsString);
    localStorage.removeItem("organization.tasks");
    localStorage.removeItem("home.tasks");

   // console.log("cadena JSON en localStorage -> ", paramsString);
    this.router.navigate(['/tasks/', (task?.organization_id ? task.organization_id : 0), (task?.id ? task.id : 0)]);
    /*const ref = this.dialogService.open(TasksDetailComponent, {
      data: {
        id: task ? task.id : 0,
        params: params2,
        prevTask: prev,
        nextTask: next
        //show_prev: (task?.task_prev != null && task?.task_prev!=0 ? true: false),
        //show_next: (task?.task_next != null && task?.task_next!=0 ? true: false) 
      },
      //header: task ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName() ,
      width: '70%'
    });*/
    /*
    ref.onClose.subscribe((data: any) => {
      this.viewsService.changeView(this.view.code);
      if (data != null) {
        this.loadPrevOrNext(data.id);
        this.tasksService.get(data).subscribe(
          data2 => {
            console.log(data2);
            this.loadPrevOrNext(data2.mode, data2.id);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        );

      } else {

        this.view.fireEvent("tasks.list.results", "reload");
      }
    })*/
  }

  delete(task) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la " + this.view.getEntityBaseName() + " con asunto '" + task.subject + "'?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.tasksService.delete(task.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.router.navigate(['/tasks']);
            this.view.fireEvent("tasks.list.results", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => { }
    })
  }

  search() {
    this.view.fireEvent("tasks.list.results", "reload");
  }

  refreshAll() {
    this.view.view?.configuration?.components?.array?.forEach(component => {
      this.view.fireEvent(component.code, "reload");
    });
  }

  onEvent(event: any) {
    if (event.event == "refreshAll" && event.action.name == "refreshAll") this.refreshAll();
    if (event.event == "reload") {
      //this.tasksFilters = event.filters;//??
    }
    if (event.component == "tasks.list.filters") {
      if (event.event == "action" && event.action.name == "search") this.search();
    } else if (event.component == "tasks.list.results") {
      if (event.event == "dblclick") this.loadPrevOrNext(event.data.id);
      if (event.event == "action" && event.action.name == "add") this.viewTask(null);
      if (event.event == "action" && event.action.name == "edit") this.loadPrevOrNext(event.data.id);
      if (event.event == "action" && event.action.name == "delete") this.delete(event.data);
    }
  }
}
